export const  aisSiteLayerSettings= {
    aisSiteLayerDefer: null,
    aisSiteLayerPromise: null,
    activeAisSite: {
      styles: {
        clickedActive: {
          fillOpacity: 0.7,
          fillColor: '#4d7c28',
          fillColor: 'red',
          strokeColor: '#ffffff',
          strokeWeight: 1,
          strokeOpacity: 1,
          zIndex: -1,
        },
        hover: {
          fillOpacity: 0.5,
          strokeColor: '#c14900',
          zIndex: 30,
          strokeWeight: 5,
        },
        selected: {
          fillOpacity: 1,
          strokeColor: '#c14900',
          zIndex: 30,
          strokeWeight: 5,
        },
        defaultState: {
          fillOpacity: 1,
          strokeColor: '#c14900',
          strokeWeight: 4,
          zIndex: 30,
        },
      },
    },
    inactiveAisSites: {
      styles: {        
        /*visible: {
          zIndex: 1,
          fillOpacity: 1,
        },
        hidden: {
          zIndex: 0,
          fillOpacity: 0,
        },
        hover: {
          fillOpacity: 1,
          strokeColor: '#FFC0CB',
          zIndex: 30,
          strokeWeight: 5,
        },
        selected: {
          fillOpacity: 1,
          strokeColor: '#FFC0CB',
          zIndex: 30,
          strokeWeight: 5,
        },*/
        defaultState: {
          fillOpacity: 0.5,
          fillColor: '#FCB724',
          strokeWeight: 0,
          zIndex: 30,
        }
      },
    },
  };